var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-intro"},[_c('img',{attrs:{"src":_vm.bannerSrc,"data-aos":"reveal-image-scale","alt":""}}),(this.title)?_c('h1',{attrs:{"data-aos":"main-title-reveal"},domProps:{"innerHTML":_vm._s(_vm.splittedTitle(this.title))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }